import { AT } from "../../../../consts";

export const PAGE_SIZE = 25;

// Plain-text template labels for the Table's Template column and mobile
// meta line — no icon, matching CalendarsPage's Template column treatment
// (design_handoff_calendars_index README §4: "no template glyphs").
export const TEMPLATE_LABELS = {
  [AT.banner]: "Banner",
  [AT.modal]: "Modal",
  [AT.alert]: "Alert",
  [AT.slider]: "Slider",
  [AT.takeover]: "Takeover",
};

export const getEditUrl = (alert) =>
  alert.integration
    ? "/alert/" + alert.uuid
    : "/alert/attach-integration/" + alert.uuid;

// Only Name and Last edited sort — matches CalendarsPage's SORT_COLUMNS
// (Integration is folded under the name rather than kept as a sortable
// column; there's no Template filter/sort per product decision).
export const SORT_COLUMNS = [
  {
    id: "name",
    sort: (direction) => (a, b) =>
      direction === "asc" ? a.name.localeCompare(b.name) : b.name.localeCompare(a.name),
  },
  {
    id: "lastEdited",
    sort: (direction) => (a, b) =>
      direction === "asc" ? a.modified - b.modified : b.modified - a.modified,
  },
];
